// extracted by mini-css-extract-plugin
export default {"canvas":"css-B2JesOvN-V","canvas_inner":"css-5POKa+TMsI","canvas_inner_background":"css-1G2XSmFrQU","logo":"css-Cbzo1AOoDH","grid":"css-BIu+8Lkjx+","shapes_dot__1":"css-9ZSAg0C-ut"};